import React from 'react';
import PropTypes from 'prop-types';
import Badge from '../Badge';
import { Types, MAX_TEXT_LENGTH, StatoOperazione } from './SnackbarUtils';
import ErroreIcon from '../Icons/ErroreIcon';
import SuccessoIcon from '../Icons/SuccessoIcon';
import Spinner from '../Spinner';
import Button from '../Button';

const printActionText = (operazione) => {
  if (operazione.type === Types.MASSIVA
    || (operazione.type === Types.ERROR
      && (operazione.message.length > MAX_TEXT_LENGTH
        || Array.isArray(operazione.message)))) {
    return 'VEDI';
  }
  return 'OK';
};

const multipleMessages = (operazione) => Array.isArray(operazione.message)
  && operazione.message.length > 1;

const printOperationHeaderMessage = (operazione) => {
  if (operazione.type === Types.MASSIVA) {
    if (operazione.stato === StatoOperazione.PENDING) {
      return 'Elaborazione in corso...';
    }
    if (operazione.stato === StatoOperazione.COMPLETED) {
      return 'Elaborazione terminata';
    }
  } else {
    if (Array.isArray(operazione.message)) {
      return `${operazione.message[0]}...`;
    }
    return operazione.message;
  }

  return null;
};

export const printIconFromType = (operazione) => {
  if (operazione.type === Types.ERROR) {
    return <ErroreIcon className="icon snackbar__iconError" />;
  }
  if (operazione.type === Types.SUCCESS) {
    return <SuccessoIcon className="icon snackbar__iconSuccess" />;
  }
  if (operazione.type === Types.WARNING) {
    return <ErroreIcon className="icon snackbar__iconWarning" />;
  }
  if (operazione.type === Types.MASSIVA
    && !(operazione.stato === StatoOperazione.COMPLETED)) {
    return <Spinner small />;
  }
  if (operazione.type === Types.MASSIVA && operazione.stato === StatoOperazione.COMPLETED) {
    if (operazione.errori.length === 0) {
      return <SuccessoIcon className="icon snackbar__iconSuccess" />;
    }
    return <ErroreIcon className="icon snackbar__iconWarning" />;
  }
  return null;
};

const HeaderOperazione = ({
  className, expanded, operazione, onOperazioneBtnClick,
}) => (
  <div className={className}>
    <div className="snackbar__iconWrapper">
      {printIconFromType(operazione)}
    </div>
    <p className="snackbar__title">{printOperationHeaderMessage(operazione)}</p>
    {!expanded && multipleMessages(operazione) && (
      <Badge
        alarm
        className="snackbar__multipleMessagesCount"
      >
        {operazione.message.length}

      </Badge>
    )}
    <div className="snackbar__actionsContainer">
      {((operazione.type === Types.MASSIVA)
        || (operazione.type === Types.ERROR && operazione.confirm)) && (
          <Button
            className="snackbar__removeBtn"
            onClick={(e) => onOperazioneBtnClick(e, operazione)}
            primary
            text
          >
            {printActionText(operazione)}
          </Button>
        )}
    </div>
  </div>
);

HeaderOperazione.propTypes = {
  className: PropTypes.string,
  expanded: PropTypes.bool,
  onOperazioneBtnClick: PropTypes.func,
  operazione: PropTypes.shape({
    type: PropTypes.number,
    confirm: PropTypes.bool,
    message: PropTypes.oneOfType([
      PropTypes.array,
      PropTypes.string,
    ]),
  }),
};

HeaderOperazione.defaultProps = {
  className: '',
  expanded: false,
  onOperazioneBtnClick: null,
  operazione: null,
};

export default HeaderOperazione;
